<template>
    <div class="sign-in">
        <div class="card card--error" v-if="error">
            <img src="@/assets/icons/ic_error.png" class="icon">
            <p>{{ error }}</p>
        </div>

        <div class="card card--success" v-if="isPasswordResetSuccess">
            <img src="@/assets/icons/ic_error.png" class="icon">
            <p>You can now use your new password.</p>
        </div>

        <form
            class="form"
            @submit.prevent="login()"
        >
            <AppTextField
                class="form__input"
                type="email"
                placeholder="Email@info.com"
                v-model="signIn.email"
                required
            >
                Email Address
            </AppTextField>

            <AppTextField
                class="form__input"
                type="password"
                placeholder="Enter Password"
                autocomplete
                v-model="signIn.password"
                required
            >
                Password
            </AppTextField>

            <a
                class="form__link"
                @click.prevent="$router.push('/forgot-password')"
            >
                Can't remember password
            </a>

            <AppButton
                class="form__button"
                modifier="large-primary-ghost"
                :disabled="loading"
            >
                {{ loading ? 'Loading...' : 'Login' }}
            </AppButton>
        </form>
    </div>
</template>

<script>
import Form from '@/class/Form'
import { mapFields } from 'vuex-map-fields'

export default {
	beforeRouteLeave (to, from, next) {
		this.clearPage()

		next()
	},

	computed: {
		...mapFields([
			'signIn',
			'loading',
			'error',
			'isPasswordResetSuccess'
		])
	},

	methods: {
		/* Login */
		async login () {
			if (this.loading) return

			this.error = ''

			const { form, validated } = await this.validate()

			if (validated) {
				const formData = new FormData()
				formData.append('email', form.get('email'))
				formData.append('password', form.get('password'))

				await this.$store.dispatch('login', { form: formData, router: this.$router })
			}
		},

		async validate () {
			const form = new Form(this.signIn)
			const data = {
				form,
				validated: true
			}

			if (!form.isValidEmail('email')) {
				data.validated = false
				this.error = 'Please enter valid Email.'
			}

			if (form.isEmptyString('password')) {
				data.validated = false
				this.error = 'Please enter your Password.'
			}

			return data
		},

		/* Before Route Leave */
		clearPage () {
			this.signIn = {
				email: '',
				password: ''
			}

			this.error = ''

			this.isPasswordResetSuccess = false
		}
	}
}
</script>
